<div class="form-group row" [formGroup]="formGroup">
  <label class="col-4 col-form-label text-right"
         [class.form-control-sm]="isSmallSize"
         [attr.for]="attributeControl.key">
    {{attributeControl.label}}<strong *ngIf="attributeControl.primaryKey" class="primaryKey">*</strong>:
  </label>

  <dk-app-attribute class="col-8" [attributeControl]="attributeControl" [formGroup]="formGroup"
                 [isSmallSize]="isSmallSize" [readonly]="readonly">
  </dk-app-attribute>

</div>
